import {
  ApiGetRequest,
  ApiBlobGetRequest,
  ApiPostRequest,
  // ApiPostRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - EDI Daily',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - EDI Daily',
        href: '/adm/opr/report/edi-daily',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_daily_edi',
    sortDesc: true,
    export: 0,
    fields: [
      {
        key: 'report_add',
        label: 'Tanggal',
      },
      {
        key: 'code_daily',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'report_name',
        label: 'Report',
      },
      {
        key: 'type_send',
        label: 'Via',
      },
      {
        key: 'report_start',
        label: 'Tgl Awal',
      },
      {
        key: 'report_end',
        label: 'Tgl Akhir',
      },
      {
        key: 'report_send',
        label: 'Tgl Kirim',
      },
      {
        key: 'report_status',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    edi_type: [],
    edi_report_type: [],
    form: {
      id_user: '',
      name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportEDIDaily(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getEdiType({ commit }, payload = null) {
    commit('reportEDIDaily', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/report/edi-daily/edi-type`, {
      id_principle: payload.id_principle,
    });

    commit('reportEDIDaily', {
      edi_type: result.data.object || [],
      loading: false,
    });

    return result.error ? false : true;
  },

  async getEdiReportType({ commit }, payload = null) {
    commit('reportEDIDaily', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/report/edi-daily/edi-report`, {
      id_principle_edi: payload.id_principle_edi,
    });

    commit('reportEDIDaily', {
      edi_report_type: result.data.object || [],
      loading: false,
    });

    return result.error ? false : true;
  },

  async getDownloadEDICustom({ commit, state }) {
    commit('reportEDIDaily', {
      loading: true,
    });

    const { data } = state;
    let params = {
      ...data.form,
      date: data.form.date ? moment(data.form.date).format('YYYY-MM-DD') : '',
    };

    let result = await ApiPostRequest(
      `opr/report/edi-daily/edi-download`,
      params
    );
    commit('reportEDIDaily', {
      loading: false,
    });

    if (!result.error) {
      var file_path = result.data.object;
      var a = document.createElement('A');
      a.href = file_path;
      a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    return result.error ? false : true;
  },

  async getReportEDIDaily({ commit, state }) {
    commit('reportEDIDaily', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: data.form.date ? moment(data.form.date).format('YYYY-MM-DD') : '',
    };
    let result = await ApiGetRequest(`opr/report/edi-daily`, params);
    commit('reportEDIDaily', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportEDIDaily({ commit, state }) {
    commit('reportEDIDaily', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: data.form.date
        ? moment(new Date(data.form.date)).format('YYYY-MM-DD')
        : '',
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/edi-daily`, params);
    commit('reportEDIDaily', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_edi_daily.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async resendEmailEDIDaily({ commit, dispatch }, payload = null) {
    commit('reportEDIDaily', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/report/edi-daily/${payload.id_daily_edi}/resend`
    );
    commit('reportEDIDaily', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async downloadDataEDI({ commit }, payload = null) {
    commit('reportEDIDaily', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/report/edi-daily/${payload.id}/download`
    );
    commit('reportEDIDaily', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      return result.data.object ? result.data.object : null;
    }
  },
};
